import Image from 'next/image';
import styled, { css } from 'styled-components';
import { Heading2, media, spacing } from '~/theme';

export const ContentSection = styled.section`
    display: flex;
    flex-direction: column;
`;

const SectionContainer = styled.section`
    padding: ${spacing.spacing5} ${spacing.spacing0};

    :last-child {
        padding-bottom: ${spacing.spacing0};
    }

    @media ${media.small} {
        padding: calc(${spacing.spacing8} + ${spacing.spacing2}) ${spacing.spacing0};

        :last-child {
            padding-bottom: ${spacing.spacing2};
        }
    }
`;

const sectionCss = css`
    display: flex;
    flex-direction: column;
    gap: ${spacing.spacing6};

    @media ${media.small} {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const RespectingYourPrivacySection = styled(SectionContainer)`
    ${sectionCss}

    @media ${media.small} {
        flex-direction: row-reverse;
    }
`;

export const SectionContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;

    p:last-child {
        margin-bottom: ${spacing.spacing0};
    }
`;

export const SectionHeading = styled(Heading2)`
    margin-bottom: ${spacing.spacing4};
`;

export const PrivacySectionImage = styled(Image)`
    max-width: 100%;
    height: auto;
`;

export default ContentSection;
